import { Helpers } from '../../helpers';
import { ITankBatterySetupSize } from '../../interfaces/itank-battery-setup-size';
import { TankBattery } from '../tank-battery';
import { TankBatterySetupTemplate } from '../tank-battery-setup-template';

export class TankBatterySetupSizeBase {
  TankBatterySetupSizeId: number;
  Name: string;
  SortOrder: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  TankBatteries_TankBatterySetupSize?: Array<TankBattery> | null;
  TankBatterySetupTemplates_TankBatterySetupSize?: Array<TankBatterySetupTemplate> | null;

  constructor(item?: ITankBatterySetupSize) {
    if (item) {

      this.TankBatterySetupSizeId = item.TankBatterySetupSizeId;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.TankBatteries_TankBatterySetupSize = Helpers.createClassArray(TankBattery, item.TankBatteries_TankBatterySetupSize);
      this.TankBatterySetupTemplates_TankBatterySetupSize = Helpers.createClassArray(TankBatterySetupTemplate, item.TankBatterySetupTemplates_TankBatterySetupSize);
    }
  }
}